import {
    Box, Button, Checkbox, FormControl, FormHelperText, MenuItem, Select,
    Stack, TextField, Typography, Autocomplete, FormControlLabel,
    InputAdornment
} from '@mui/material'
import React, { Component } from 'react'
import { Colors } from '../../../../Styles/Colors'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation'
import { calculateBMI, calculateWeeksAndDays, calculateBSA } from '../../../../Components/CommonFunctions/CommonFunctions'
import { withTranslation } from 'react-i18next';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from 'luxon';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService'
import { DateTimePicker, LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { oxygen_source_list } from "../../../../Utility/Constants";


class DocVitalsRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            patientId: this.props.PatientData?.patient_id,
            clinicId: this.props.clinicId,
            appointmentId: this.props.PatientData?.appointment_id,
            height: '',
            weight: '',
            bp_d: '',
            bp_s: '',
            temp: '',
            spo2: '',
            pulserate: '',
            bloodglucouse: '',
            postLoading: false,
            tempUnit: 'F',
            vitalsData: [],
            loading: false,
            isLocked: false,
            bmi: 0.00,
            bsa: 0.00,
            headCircumference: '',
            obs_ExpectedDeliveryDate: null,
            obs_LastMenstrualPeriod: null,
            gestational_weeks: "",
            gestational_days: "",
            DeliverydateCalac: false,
            GestationalCalculation: false,
            waist_circumference: '',
            vitalDate: new Date(),
            show_waist_circumference: false,
            right_Fields_data: this.props?.right_Fields_data || [],
            filteredRightField_data : this.props?.filteredRightField_data || [],
            comments: "",
            nurseName: null,
            NurseList: [],
            oxygen_source: "",
            oxygen_support: "",
            corrected_edd: null,
            heartRate: "",
            respiratoryRate: "",
            capillaryRefillTime: "",
        }
    }

    componentDidMount() {
        this.getNurseList()
        let show_waist_circumference = JSON.parse(localGetItem('loggedInUserInfo'))?.show_waist_circumference
        this.setState({ show_waist_circumference: show_waist_circumference })
        if (JSON.stringify(this.props?.EditVitalsData)) {
            this.assignEditVitals();
        }
    }
    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps?.EditVitalsData) !== JSON.stringify(this.props?.EditVitalsData)){
            this.assignEditVitals();
        }
    }

    assignEditVitals = () => {
        const { EditVitalsData } = this.props;
        if (EditVitalsData?.length > 0) {
            const vitals = EditVitalsData[0];
            this.setState({
                vitalsData: EditVitalsData,
                height: vitals?.height_cm,
                weight: vitals?.weight_kg,
                bp_d: vitals?.blood_pressure_diastolic,
                bp_s: vitals?.blood_pressure_systolic,
                temp: vitals?.temperature,
                spo2: vitals?.pulse_oximetry,
                pulserate: vitals?.pulse_rate,
                bloodglucouse: vitals?.blood_sugar,
                tempUnit: vitals?.temperature_unit,
                bmi: vitals?.bmi,
                bsa: vitals?.bsa,
                headCircumference: vitals?.head_circumference,
                obs_ExpectedDeliveryDate: vitals?.expected_date_of_delivery,
                DeliverydateCalac: vitals?.expected_date_of_delivery ? true : false,
                GestationalCalculation: (vitals?.gestational_age_weeks || vitals?.gestational_age_days) ? true : false,
                obs_LastMenstrualPeriod: vitals?.last_menstrual_period,
                gestational_weeks: vitals?.gestational_age_weeks,
                gestational_days: vitals?.gestational_age_days,
                waist_circumference: vitals?.waist_circumference,
                postLoading: true,
                loading: false,
                vitalDate: vitals?.vital_entered_time ? vitals?.vital_entered_time : new Date(),
                comments: vitals?.comments,
                nurseName: (vitals?.nurse_name && vitals?.nurse_profile_id) ? {
                    "nurse": vitals?.nurse_name || "",
                    "staff_id": vitals?.nurse_profile_id || ""
                } : null,
                oxygen_source: vitals?.oxygen_source || "",
                oxygen_support: vitals?.oxygen_support || "",
                corrected_edd: vitals?.corrected_edd || null,
                heartRate: vitals?.heart_rate || "",
                respiratoryRate: vitals?.respiratory_rate || "",
                capillaryRefillTime: vitals?.capillary_refill_time || "",
            })
        }
    }

    getNurseList = () => {
        try {
            let clinicID =  getCachevalue('SelectedDoctorClinic')
            // const clinicID = getCachevalue("SelectedDoctorClinic") ? JSON.parse(getCachevalue("SelectedDoctorClinic")) : null;
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${clinicID}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            NurseList: response.data.data
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    postDoctorNotesVitalData = () => {
        try {
            let states = this.state
            const date = DateTime.fromJSDate(this.state.vitalDate ? new Date(states.vitalDate) : new Date()).toFormat("yyyy-MM-dd hh:mm:ss a");
            
            let data = {
                appointment_id: this.props.PatientData?.appointment_id,
                blood_pressure_diastolic: +states.bp_d,
                blood_pressure_systolic: +states.bp_s,
                blood_sugar: +states.bloodglucouse,
                bmi: states.height && states.weight ? states.bmi : null,
                bsa: states.height && states.weight ? states.bsa : null,
                height_cm: +states.height,
                pulse_rate: +states.pulserate,
                vital_entered_time: date,
                pulse_oximetry: +states.spo2,
                temperature: +states.temp,
                temperature_unit: states.tempUnit,
                weight_kg: +states.weight,
                dataDisable: true,
                head_circumference: this.state.headCircumference ? +this.state.headCircumference : null,
                gestational_age_days: this.state.gestational_days ? this.state.gestational_days : "",
                gestational_age_weeks: this.state.gestational_weeks ? this.state.gestational_weeks : "",
                last_menstrual_period: this.state.obs_LastMenstrualPeriod ? DateTime.fromJSDate(new Date(this.state.obs_LastMenstrualPeriod)).toFormat("yyyy-MM-dd") : null,
                expected_date_of_delivery: this.state.obs_ExpectedDeliveryDate ? DateTime.fromJSDate(new Date(this.state.obs_ExpectedDeliveryDate)).toFormat("yyyy-MM-dd") : null,
                waist_circumference: this.state.waist_circumference ? this.state.waist_circumference : null,
                comments: this.state.comments || "",
                nurse_profile_id: this.state.nurseName === null ? "" : this.state.nurseName.staff_id,
                oxygen_source: this.state.oxygen_source || "",
                oxygen_support: this.state.oxygen_support || "",
                corrected_edd: this.state.corrected_edd ? DateTime.fromJSDate(new Date(this.state.corrected_edd)).toFormat("yyyy-MM-dd") : null,
                heart_rate: this.state.heartRate || null,
                respiratory_rate: this.state.respiratoryRate || null,
                capillary_refill_time: this.state.capillaryRefillTime || null,
            }
            if (
                (this.state.height !== "") || (this.state.weight !== "") ||
                (this.state.bp_s !== "") || (this.state.bp_d !== "") ||
                (this.state.temp !== "") || (this.state.spo2 !== "") || (this.state.waist_circumference !== '') ||
                (this.state.bloodglucouse !== "") || (this.state.pulserate !== "") || (this.state.headCircumference !== "") ||
                (this.state.gestational_days !== "") || (this.state.gestational_weeks !== "") || (this.state.obs_LastMenstrualPeriod !== null) ||
                (this.state.comments !== "") || (this.state.nurseName !== null) || (this.state.obs_ExpectedDeliveryDate !== null) ||
                (this.state.corrected_edd !== null) || (this.state.heartRate !== "") || (this.state.respiratoryRate !== "") || (this.state.capillaryRefillTime !== "")
            ) {
                this.setState({ postLoading: true })
                RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_VITALS)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            this.setState({ postLoading: false })
                            this.successMessage(response.data.message)
                            // this.getDoctorNotesVitalData()
                            // this.ClearData()
                            this.props.CallgetApi('vitals')
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            this.setState({ postLoading: false })
                            this.errorMessage(error?.response?.data?.message)
                        } else {
                            this.setState({ postLoading: false })
                            this.errorMessage(error.message)
                        }
                    })
            } else {
                this.errorMessage('Enter atleast one data')
            }
        } catch (error) {
            this.setState({ postLoading: false })
            this.errorMessage(error.message)
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    ClearData = () => {
        try {
            this.setState({
                height: '',
                weight: '',
                bp_d: '',
                bp_s: '',
                temp: '',
                spo2: '',
                pulserate: '',
                bloodglucouse: '',
                tempUnit: 'F',
                obs_ExpectedDeliveryDate: null,
                obs_LastMenstrualPeriod: null,
                gestational_weeks: "",
                gestational_days: "",
                DeliverydateCalac: false,
                temp: "", 
                vitalDate: new Date(),
                GestationalCalculation: false,
                waist_circumference: '',
                comments: "",
                nurseName: null,
                headCircumference: '',
                bmi: 0.00,
                bsa: 0.00,
                corrected_edd: null,
                heart_rate: '',
                capillaryRefillTime: '',
                respiratoryRate: '',
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    onChangeHandler = (e, names) => {
        try {
            let value = e.target.value
            let num = CommonValidation.DecimalNumber(value)
            switch (names) {
                case "height":
                    if ((num && value >= 1 && value <= 230) || value === "") {
                        this.setState({ height: value }, () => {
                            let bmi = calculateBMI(this.state.weight, this.state.height)
                            const bsa = calculateBSA(value, this.state.weight)
                            this.setState({
                                bmi: bmi?.toFixed(2),
                                bsa: bsa?.toFixed(2),
                            })
                        })
                    }
                    break;
                case "weight":
                    if ((num && value >= 1 && value <= 500) || value === "") {
                        this.setState({ weight: value }, () => {
                            let bmi = calculateBMI(this.state.weight, this.state.height)
                            const bsa = calculateBSA(this.state.height, value)
                            this.setState({
                                bmi: bmi?.toFixed(2),
                                bsa: bsa?.toFixed(2),
                            })
                        })
                    }
                    break;
                case "heartRate":
                    if ((num && value >= 1 && value <= 250) || value === "") {
                        this.setState({ heartRate: value });
                    }
                    break;

                case "respiratoryRate":
                    if ((num && value >= 1 && value <= 80) || value === "") {
                        this.setState({ respiratoryRate: value });
                    }
                    break;

                case "capillaryRefillTime":
                this.setState({ capillaryRefillTime: value });
                break;
                case "bp_d":
                    if ((num && value >= 1 && value <= 200) || value === "") {
                        this.setState({ bp_d: value })
                    }
                    break;
                case "bp_s":
                    if ((num && value >= 1 && value <= 250) || value === "") {
                        this.setState({ bp_s: value })
                    }
                    break;
                case "temp":
                    if ((this.state.tempUnit === "F" && num && value >= 1 && value <= 248) || value === "") {
                        this.setState({ temp: value })
                    } else if ((this.state.tempUnit === "C" && num && value >= 1 && value <= 200) || value === "") {
                        this.setState({ temp: value })
                    }
                    break;
                case "spo2":
                    if ((num && value >= 1 && value <= 100) || value === "") {
                        this.setState({
                            spo2: value,
                            ...(value === "" && {
                                oxygen_source: "",
                                oxygen_support: ""
                            })
                        });
                    }
                    break;
                case "pulserate":
                    if ((num && value >= 1 && value <= 150) || value === "") {
                        this.setState({ pulserate: value })
                    }
                    break;
                case "bloodglucouse":
                    if ((num && value >= 1 && value <= 999) || value === "") {
                        this.setState({ bloodglucouse: value })
                    }
                    break;
                case "headCircumference":
                    if ((num && value >= 1 && value <= 56) || value === "") {
                        this.setState({ headCircumference: value })
                    }
                    break;
                case "waist_circumference":
                    if ((num && value >= 1 && value <= 999) || value === "") {
                        this.setState({ waist_circumference: value })
                    }
                    break;
                case "gestational_weeks":
                    if ((num && value >= 1 && value <= 45) || value === "") {
                        const newValue = value.replace(/^0+/, "");
                        this.setState({ gestational_weeks: newValue?.trim() }, () => {
                            if (this.state.gestational_days || this.state.gestational_weeks) {
                                this.setState({ GestationalCalculation: true })
                            } else {
                                this.setState({ GestationalCalculation: false })
                            }
                        })
                    }
                    break;
                case "gestational_days":
                    if ((num && value >= 1 && value <= 6) || value === "") {
                        const newValue = value.replace(/^0+/, "");
                        this.setState({ gestational_days: newValue?.trim() }, () => {
                            if (this.state.gestational_days || this.state.gestational_weeks) {
                                this.setState({ GestationalCalculation: true })
                            } else {
                                this.setState({ GestationalCalculation: false })
                            }
                        })
                    }
                    break;
                case "oxygen_support":
                    if ((num && value >= 1 && value <= 100) || value === "") {
                        this.setState({ oxygen_support: value })
                    }
                    break;
                default:
                    this.setState({
                        [names]: value
                    })
                    break;
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderTextBox = (names, value, width, endAdornment, placeholder, color) => {
        try {
            return (
                <TextField
                    emed_tid={`vitals_${names}_textfield`}
                    size='small'
                    sx={{ width: width }}
                    name={names}
                    autoComplete='off'
                    value={value}
                    placeholder={placeholder}
                    inputProps={{ maxLength: names === "comments" ? 100 : null, style: { color: color, fontWeight: '600' }, emed_tid: names }}
                    onChange={(e) => this.onChangeHandler(e, names)}
                    InputProps={{
                        endAdornment: names === 'temp' ?
                            <FormControl size='small' emed_tid="tempUnit">
                                <Select
                                    sx={{ width: '3vw' }}
                                    variant='standard'
                                    value={this.state.tempUnit}
                                    onChange={(e) => this.setState({ tempUnit: e.target.value })}
                                    emed_tid="tempUnitSelect"
                                >
                                    <MenuItem value={'F'} emed_tid="tempUnitF">{'°F'}</MenuItem>
                                    <MenuItem value={'C'} emed_tid="tempUnitC">{'°C'}</MenuItem>
                                </Select>
                            </FormControl>
                            :
                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid={`${names}Unit`}>{endAdornment}</Typography>
                    }}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    bmiHelperText = (bmi) => {
        try {
            let message = null
            if (bmi <= 18.5) {
                message = 'Mild Thinness'
            } else if (bmi > 18.5 && bmi <= 25) {
                message = 'Normal'
            } else if (bmi > 25 && bmi <= 30) {
                message = 'Overweight'
            } else if (bmi > 30) {
                message = 'Obesity'
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    bsaHelperText = (bsa) => {
        try {
            let message = null
            if (bsa < 1.4) {
                message = 'Below Normal'
            } else if (bsa >= 1.4 && bsa <= 2.4) {
                message = 'Normal Range'
            } else if (bsa > 2.4) {
                message = 'Above Normal'
            }
            return message;
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderObgynDatePicker = (stateKey, disable) => {
        let states = this.state
        return (
            <Box emed_tid={`${stateKey}Picker`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        emed_tid={`vitals_${stateKey}_datepicker`}
                        value={states[stateKey] ? states[stateKey] : null}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        maxDate={stateKey === "obs_LastMenstrualPeriod" ? new Date() : null}
                        minDate={stateKey === "obs_ExpectedDeliveryDate" || stateKey === "corrected_edd" ? new Date() : null}
                        disabled={disable}
                        onChange={(newDate) => {
                            if (stateKey === "obs_LastMenstrualPeriod") {
                                states[stateKey] = newDate
                                states["obs_ExpectedDeliveryDate"] = new Date(new Date(newDate).getTime() + 40 * 7 * 24 * 60 * 60 * 1000);
                                // Calculate weeks and days between newDate and today
                                const { weeks, days } = calculateWeeksAndDays(new Date(newDate), new Date());
                                states["DeliverydateCalac"] = true;
                                states["GestationalCalculation"] = true;
                                states["gestational_weeks"] = weeks?.toString();
                                states["gestational_days"] = days?.toString();
                            } else {
                                if (stateKey === "obs_ExpectedDeliveryDate") {
                                    states["DeliverydateCalac"] = true;
                                }
                                states[stateKey] = newDate
                            }
                            this.setState({ states })
                        }}
                        renderInput={(params) => <TextField
                            sx={{ width: "13dvw" }}
                            autoComplete='off'
                            onKeyDown={(e) => e.preventDefault()}
                            size='small' {...params} inputProps={{ ...params.inputProps, emed_tid: stateKey }} />}
                    />
                </LocalizationProvider>
            </Box>)
    }

    NurseSelection = () => {
        return (
            <Autocomplete
                size='small'
                options={this.state.NurseList}
                getOptionLabel={(option) => option.nurse}
                value={this.state.nurseName}
                onChange={(event, newValue) => {
                    this.setState({
                        nurseName: newValue
                    })
                }}
                emed_tid="nurseSelection"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        sx={{ width: "13vw" }}
                        inputProps={{ ...params.inputProps, 'emed_tid': 'NurseName', }}
                    />
                )}
            />
        )
    }

    renderSelect = (stateKey, list = [], isDisable = false, showKey = "label", valueKey = "value") => {
        return (
            <Select
                sx={{ width: '13vw', fontSize: '0.95vw' }}
                size='small'
                value={this.state[stateKey]}
                onChange={(e) => { this.setState({ [stateKey]: e.target.value, oxygen_support: "" }) }}
                disabled={isDisable}
                emed_tid={stateKey}
            >
                {list?.map((item, index) => (
                    <MenuItem sx={{ fontSize: '0.95vw' }} key={item[valueKey]} value={item[valueKey]} emed_tid={`${stateKey}Option${index}`}>{item[showKey]}</MenuItem>
                ))}
            </Select>
        )
    }

    render() {
        let bpsColor = this.state.bp_s <= 120 ? "green" : "red"
        let bpdColor = this.state.bp_d <= 80 ? "green" : "red"
        let tempColor = ((this.state.tempUnit === 'F' && (this.state.temp >= 97 && this.state.temp <= 99)) || (this.state.tempUnit === 'C' && (this.state.temp >= 36.1 && this.state.temp <= 37.2))) ? 'green' : 'red'
        let spo2Color = (this.state.spo2 >= 95 && this.state.spo2 <= 100) ? "green" : "red"
        let rateColor = (this.state.pulserate >= 60 && this.state.pulserate) ? 'green' : 'red'
        let bloodColor = this.state.bloodglucouse <= 200 ? 'green' : 'red'
        let heartRateColor =
            this.state.heartRate >= 60 && this.state.heartRate <= 100
                ? "green"
                : "red"

        let respiratoryColor =
            this.state.respiratoryRate >= 12 && this.state.respiratoryRate <= 20
                ? "green"
                : "red"

        let capillaryColor =
            this.state.capillaryRefillTime === "<2"
                ? "green"
                : this.state.capillaryRefillTime === ">2-<3"
                    ? "orange"
                    : this.state.capillaryRefillTime === ">3"
                        ? "red"
                        : ""
        const { t } = this.props
        return (
            <Box emed_tid="docVitalsRightMain">
                <Typography className='eMed_refdoc_title' emed_tid="docVitalsRightTitle">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Vitals'}</Typography>
                <Box height={"56.3vh"} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: 'scroll' }} emed_tid="docVitalsRightContent">
                    <Box component={'div'} width={'28dvw'} sx={{ backgroundColor: Colors.white }} paddingTop={'1vw'} emed_tid="docVitalsRightFields">
                        {this.state.right_Fields_data?.map((item, index) => {
                            const hasSys = this.state.filteredRightField_data?.some(f => f.field_name === 'bpsystolic');
                            const hasDys = this.state.filteredRightField_data?.some(f => f.field_name === 'bpdistolic');
                            if (item?.is_active || item?.field_name === 'bpsystolic') {
                                return (
                                    <Box emed_tid={`fieldWrapper${index}`}>
                                        {item?.field_name === 'height' ? <Box component={'div'} mt={'0.5vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} emed_tid="heightField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="heightLabel">Height</Typography>
                                            {this.renderTextBox('height', this.state.height, '13vw', 'cm')}
                                        </Box> : null}
                                        {item?.field_name === 'weight' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="weightField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="weightLabel">Weight</Typography>
                                            {this.renderTextBox('weight', this.state.weight, '13vw', 'kg')}
                                        </Box> : null}
                                        {item?.field_name === 'heart_rate' ? <Box component={'div'} display="flex" mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="heartRateField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="heartRateLabel">Heart Rate</Typography>
                                            {this.renderTextBox('heartRate', this.state.heartRate, '13vw', 'bpm', '', heartRateColor)}
                                        </Box> : null}
                                        {item?.field_name === 'respiratory_rate' ? <Box component={'div'} display="flex" mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="respiratoryRateField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="respiratoryRateLabel">Respiratory Rate</Typography>
                                            {this.renderTextBox('respiratoryRate', this.state.respiratoryRate, '13vw', 'breaths/min', '', respiratoryColor)}
                                        </Box> : null}
                                        {item?.field_name === 'capillary_refill_time' ? (
                                            <Box
                                                component={'div'}
                                                display="flex"
                                                mt={'0.5vw'}
                                                justifyContent={'space-between'}
                                                alignItems={'center'}
                                                emed_tid="capillaryRefillTimeField"
                                            >
                                                <Typography
                                                    fontWeight={600}
                                                    fontSize={'0.9vw'}
                                                    color={Colors.SecondaryText}
                                                    emed_tid="capillaryRefillTimeLabel"
                                                >
                                                    Capillary Refill Time
                                                </Typography>

                                                <FormControl size="small" sx={{ width: '13vw' }} emed_tid="capillaryRefillTimeControl">
                                                    <TextField
                                                        emed_tid='vitals_capillary_refill_time_select'
                                                        select
                                                        size="small"
                                                        name="capillaryRefillTime"
                                                        value={this.state.capillaryRefillTime}
                                                        onChange={(e) => this.setState({ capillaryRefillTime: e.target.value })}
                                                        sx={{
                                                            '& .MuiSelect-select': {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                color: capillaryColor,
                                                                fontWeight: '600'
                                                            }
                                                        }}
                                                        inputProps={{ emed_tid: 'capillaryRefillTime' }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end" emed_tid="capillaryRefillTimeUnit">
                                                                    <Typography fontSize={'1vw'} sx={{ fontWeight:"600"}} emed_tid="capillaryRefillTimeUnitText">
                                                                        sec
                                                                    </Typography>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                        SelectProps={{
                                                            MenuProps: {
                                                                PaperProps: {
                                                                    sx: { maxHeight: 200 }
                                                                }
                                                            },
                                                            IconComponent: () => null
                                                        }}
                                                    >
                                                        <MenuItem value="<2" emed_tid="capillaryRefillTimeOption1">≤ 2</MenuItem>
                                                        <MenuItem value=">2-<3" emed_tid="capillaryRefillTimeOption2">{'> 2 - < 3'}</MenuItem>
                                                        <MenuItem value=">3" emed_tid="capillaryRefillTimeOption3">≥ 3</MenuItem>
                                                    </TextField>
                                                </FormControl>
                                            </Box>
                                        ) : null}

                                        {(this.state.height && this.state.weight) && (item?.field_name === 'bmi') ?
                                            <Box component={'div'} width={"100%"}
                                                sx={{ backgroundColor: this.state.bmi < 18.5 ? '#FFCCCB' : ((this.state.bmi >= 18.5) && (this.state.bmi <= 25)) ? 'lightgreen' : ((this.state.bmi > 25) && (this.state.bmi <= 30)) ? '#FBB917' : '#FF6863' }}
                                                display={'flex'} borderRadius={'5px'} mt={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'} emed_tid="bmiBox">
                                                <Typography fontWeight={600} fontSize={'0.9vw'} emed_tid="bmiLabel">BMI</Typography>
                                                <FormHelperText emed_tid="bmiHelper">
                                                    <Typography fontWeight={600} fontSize={'0.8vw'} emed_tid="bmiHelperText">{this.bmiHelperText(this.state.bmi)}</Typography>
                                                </FormHelperText>
                                                <Typography fontWeight={600} fontSize={'0.9vw'} emed_tid="bmiValue">{this.state.bmi}</Typography>
                                            </Box> : null}
                                        {(this.state.height && this.state.weight) && (item?.field_name === 'bsa') ?
                                            <Box component={'div'}
                                                sx={{ backgroundColor: ((this.state.bsa >= 1.4) && (this.state.bsa <= 2.4)) ? 'lightgreen' : ((this.state.bsa < 1.4)) ? '#FBB917' : '#FF6863' }}
                                                display={'flex'} borderRadius={'5px'} mt={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'} emed_tid="bsaBox">
                                                <Typography fontWeight={600} fontSize={'0.9vw'} emed_tid="bsaLabel">BSA</Typography>
                                                <FormHelperText emed_tid="bsaHelper">
                                                    <Typography fontWeight={600} fontSize={'0.8vw'} emed_tid="bsaHelperText">{this.bsaHelperText(this.state.bsa)}</Typography>
                                                </FormHelperText>
                                                <Typography fontWeight={600} fontSize={'0.9vw'} emed_tid="bsaValue">{this.state.bsa}</Typography>
                                            </Box> : null}
                                        {((hasDys && !hasSys) || (!hasDys && hasSys) || (hasDys && hasSys)) && item?.field_name === 'bpsystolic' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="bpField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="bpLabel">{'BP | S > D'}</Typography>
                                            <Box component={'div'} emed_tid="bpInputs">
                                                {hasSys ? <TextField
                                                    size='small'
                                                    sx={{ width: '5vw' }}
                                                    value={this.state.bp_s}
                                                    placeholder='S'
                                                    onChange={(e) => this.onChangeHandler(e, 'bp_s')}
                                                    inputProps={{ style: { color: bpsColor, fontWeight: '600' }, emed_tid: 'bp_s' }}
                                                /> : null}
                                                {hasDys ? this.renderTextBox('bp_d', this.state.bp_d, '8vw', 'mm/Hg', 'D', bpdColor) : null}
                                            </Box>
                                        </Box> : null}
                                        {item?.field_name === 'temp' ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="tempField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="tempLabel">Temp</Typography>
                                            {this.renderTextBox('temp', this.state.temp, '13vw', '', '', tempColor)}
                                        </Box> : null}
                                        {item.field_name === "spo2" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="spo2Field">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="spo2Label">SpO2</Typography>
                                            {this.renderTextBox('spo2', this.state.spo2, '13vw', '%', '', spo2Color)}
                                        </Box> : null}
                                        {item?.field_name === 'oxygensource' ?
                                            <Box emed_tid="oxygenSourceField">
                                                <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="oxygenSourceInput">
                                                    <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="oxygenSourceLabel">{"Oxygen Source"}</Typography>
                                                    {this.renderSelect("oxygen_source", oxygen_source_list, !this.state.spo2)}
                                                </Box>
                                                {
                                                    this.state.oxygen_source === "O2 (With Oxygen)" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="oxygenSupportField">
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="oxygenSupportLabel">{"Oxygen Support"}</Typography>
                                                        {this.renderTextBox("oxygen_support", this.state.oxygen_support, "13vw", "L/min")}
                                                    </Box>
                                                }
                                            </Box> : null}
                                        {item.field_name === "pulse" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="pulseField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="pulseLabel">Pulse Rate</Typography>
                                            {this.renderTextBox('pulserate', this.state.pulserate, '13vw', '/min', '', rateColor)}
                                        </Box> : null}
                                        {item.field_name === "blood_glucose" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="bloodGlucoseField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="bloodGlucoseLabel">Blood Glucose</Typography>
                                            {this.renderTextBox('bloodglucouse', this.state.bloodglucouse, '13vw', 'mg/DL', '', bloodColor)}
                                        </Box> : null}
                                        {
                                            <>
                                                {item.field_name === "last_mensural" ? <Box component={'div'} display={'flex'} mt={'0.5dvw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="lastMenstrualPeriodField">
                                                    <Typography fontWeight={600} fontSize={'0.9dvw'} color={Colors.SecondaryText} emed_tid="lastMenstrualPeriodLabel">Last Menstrual Period</Typography>
                                                    {this.renderObgynDatePicker("obs_LastMenstrualPeriod")}
                                                </Box> : null}
                                                {item.field_name === "expected_date_of_delivery" ?
                                                    <Box component={'div'} display={'flex'} mt={'0.5dvw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="expectedDeliveryDateField">
                                                        <FormControlLabel
                                                            emed_tid='vitals_expected_delivery_checkbox'
                                                            control={
                                                                <Checkbox
                                                                    size="small"
                                                                    emed_tid="expectedDeliveryDateCheckbox"
                                                                    disabled={this.state.obs_LastMenstrualPeriod === null && this.state.obs_ExpectedDeliveryDate === null}
                                                                    checked={this.state.DeliverydateCalac}
                                                                    onChange={(e) => {
                                                                        this.setState({ DeliverydateCalac: !this.state.DeliverydateCalac }, () => {
                                                                            if (this.state.DeliverydateCalac) {
                                                                                this.setState({
                                                                                    obs_ExpectedDeliveryDate: new Date(
                                                                                        new Date(this.state.obs_LastMenstrualPeriod).getTime() + 40 * 7 * 24 * 60 * 60 * 1000
                                                                                    )
                                                                                });
                                                                            } else {
                                                                                this.setState({ obs_ExpectedDeliveryDate: null });
                                                                            }
                                                                        });
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography fontWeight={600} fontSize="0.9dvw" color={Colors.SecondaryText} emed_tid="expectedDeliveryDateLabel">
                                                                    Expected date of delivery
                                                                </Typography>
                                                            }
                                                        />
                                                        {this.renderObgynDatePicker("obs_ExpectedDeliveryDate")}
                                                    </Box> : null}
                                                {item.field_name === "gestational_age" ?
                                                    <Box component={'div'} width={"100%"} display="flex" mt={'0.5dvw'} mb={'0.625dvw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="gestationalAgeField">
                                                        <FormControlLabel
                                                            emed_tid='vitals_gestational_age_checkbox'
                                                            control={<Checkbox
                                                                size='small'
                                                                emed_tid="gestationalAgeCheckbox"
                                                                disabled={this.state.obs_LastMenstrualPeriod === null && this.state.gestational_weeks === "" && this.state.gestational_days === ""}
                                                                checked={this.state.GestationalCalculation} onChange={(e) => {
                                                                    this.setState({ GestationalCalculation: !this.state.GestationalCalculation }, () => {
                                                                        if (this.state.GestationalCalculation) {
                                                                            const { weeks, days } = calculateWeeksAndDays(new Date(this.state.obs_LastMenstrualPeriod), new Date());
                                                                            this.setState({
                                                                                gestational_weeks: weeks?.toString(),
                                                                                gestational_days: days?.toString(),
                                                                            })
                                                                        } else {
                                                                            this.setState({
                                                                                gestational_weeks: "",
                                                                                gestational_days: "",
                                                                            })
                                                                        }
                                                                    })
                                                                }} />}
                                                            label={
                                                                <Typography fontWeight={600} fontSize="0.9dvw" color={Colors.SecondaryText} emed_tid="gestationalAgeLabel">
                                                                    Gestational Age
                                                                </Typography>
                                                            }
                                                        />
                                                        <Box component={'div'} display="flex" justifyContent={'space-between'} alignItems={'center'} emed_tid="gestationalAgeInputs">
                                                            {this.renderTextBox("gestational_weeks", this.state.gestational_weeks, "6.5dvw", "Weeks")}
                                                            {this.renderTextBox("gestational_days", this.state.gestational_days, "6.5dvw", "Days")}
                                                        </Box>
                                                    </Box> : null}
                                                {item.field_name === "corrected_edd" ?
                                                    <Box component={'div'} display={'flex'} mt={'0.5dvw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="correctedEddField">
                                                        <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="correctedEddLabel">Corrected EDD</Typography>
                                                        {this.renderObgynDatePicker("corrected_edd")}
                                                    </Box> : null}
                                            </>}
                                        {(item.field_name === "head_circumference") ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="headCircumferenceField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="headCircumferenceLabel">Head Circumference</Typography>
                                            {this.renderTextBox('headCircumference', this.state.headCircumference, '13vw', 'CM')}
                                        </Box> : null}
                                        {(item.field_name === "waist_circumference") ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="waistCircumferenceField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="waistCircumferenceLabel">Waist Circumference</Typography>
                                            {this.renderTextBox('waist_circumference', this.state.waist_circumference, '13vw', 'CM')}
                                        </Box> : null}
                                        {item.field_name === "vital_data_time" ? <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="vitalDateTimeField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="vitalDateTimeLabel">Vital Date and Time</Typography>
                                            <Box component={'span'} sx={{ backgroundColor: Colors.ThemeLightColor, width: "13vw" }} className="eMed_Time_Style" emed_tid="vitalDateTimePicker">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DateTimePicker
                                                        emed_tid='vitals_vital_date_time_picker'
                                                        inputFormat='DD-MM-YYYY & hh:mm A'
                                                        value={this.state.vitalDate}
                                                        name={"vitalDate"}
                                                        onChange={(newDate) => {
                                                            if (newDate === null) {
                                                                this.setState({
                                                                    vitalDate: new Date()
                                                                })
                                                            } else {
                                                                this.setState({ vitalDate: newDate })
                                                            }
                                                        }}
                                                        renderInput={(params) => <TextField size='small'
                                                            {...params}
                                                            variant='standard'
                                                            fullWidth
                                                            sx={{ marginTop: "1.5vw", width: "13vw" }}
                                                            inputProps={{ ...params.inputProps, emed_tid: 'vitalDate' }}
                                                        />}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </Box> : null}
                                        {item.field_name === "comments" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="commentsField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="commentsLabel">Comments</Typography>
                                            {this.renderTextBox('comments', this.state.comments, '13vw', '', '', "")}
                                        </Box>}
                                        {item.field_name === "nurse_name" && <Box component={'div'} display={'flex'} mt={'0.5vw'} justifyContent={'space-between'} alignItems={'center'} emed_tid="nurseNameField">
                                            <Typography fontWeight={600} fontSize={'0.9vw'} color={Colors.SecondaryText} emed_tid="nurseNameLabel">Nurse Name</Typography>
                                            {this.NurseSelection()}
                                        </Box>}
                                    </Box>)
                            }
                        })}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="docVitalsRightActions">
                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="docVitalsRightClear">{t("Clear")}</Button>
                    <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { this.postDoctorNotesVitalData() }} emed_tid="docVitalsRightAdd">{t("Add")}</Button>
                </Stack>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="docVitalsRightError"
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                        emed_tid="docVitalsRightSuccess"
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(DocVitalsRight)
